module.exports = __webpack_public_path__ + "static/media/mancolaxyl_72_wp.cec46e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/mildiu_pepino/curativa/mancolaxyl_72_wp.png
// module id = 2111
// module chunks = 3